import React from "react";
import CText from "../Components/CText";
import { Row, Col } from "reactstrap";
import Alab from "../assets/Alab-logo.png";
import KamelPay from "../assets/KamelPay-logo.png";
import KOLnet from "../assets/KOLnet-Logo.svg";
import Sageverse from "../assets/Sageverse-logo.png";
import dafi from "../assets/dafi-logo.svg";
import SonarWallet from "../assets/sonar-wallet-logo.svg";

function Experience({ refElement }) {
  return (
    <div className="experienceSection" ref={refElement}>
      <CText
        fontSize="2.5rem"
        className="subHeading cw"
        text="I'm proud to have collaborated with some awesome companies"
      />
      <Row className="mb-5 flex align-items-center" lg="3" xs="2">
        <Col style={{ marginBottom: "60px" }} className="">
          <img className="logo" src={KOLnet} />
        </Col>
        <Col style={{ marginBottom: "60px" }} className="">
          <img className="logo" src={dafi} />
        </Col>
        <Col style={{ marginBottom: "60px" }} className="">
          <img width={"70%"} style={{ minWidth: "150px" }} src={SonarWallet} />
        </Col>

        <Col style={{ marginBottom: "60px" }} className="">
          <img className="logo" src={KamelPay} />
        </Col>

        <Col style={{ marginBottom: "60px" }} className="">
          <img className="logo" src={Alab} />
        </Col>
        <Col style={{ marginBottom: "60px" }} className="">
          <img className="logo" src={Sageverse} />
        </Col>
      </Row>
    </div>
  );
}

export default Experience;
